import { Link } from "react-router-dom"

export default function AuthShell({ children, showRegisterLink = true }) {
  return (
    <div className="flex w-screen max-h-screen overflow-hidden font-oswald bg-[#00072D] lg:bg-gray-50">
      <div className="flex w-screen items-center justify-center lg:w-1/2 overflow-y-auto max-h-screen py-6">
        {children}
      </div>

      <div className="hidden lg:flex w-1/2 rounded-l-3xl bg-gradient-to-tr from-[#00072D] to-[#1A43BF] drop-shadow-2xl">
        <div className="flex flex-col w-full h-full">
          <div className="flex-1 flex flex-col justify-center pl-11 py-8">
            <div className="text-start">
              <h1 className="mb-4 text-6xl font-semibold text-slate-200">
                SEJA SUA SEGURANÇA
              </h1>
              <h1 className="mb-4 text-6xl font-semibold text-slate-200">
                TENHA CONFIANÇA
              </h1>
              <h1 className="mb-4 text-6xl font-semibold text-slate-200">
                E CONTROLE EMOCIONAL
              </h1>

              <div className="bg-[#3e6aee] p-4 rounded-lg mt-24 mr-4 shadow-lg">
                <h1 className="text-4xl font-semibold text-slate-200">
                  É com imensa alegria que te recebemos novamente em nosso
                  espaço virtual!
                </h1>
                <p className="text-3xl mt-2 font-sans text-slate-200">
                  Sua presença é fundamental para nós e estamos entusiasmados em
                  compartilhar tudo o que preparamos para você.
                </p>
              </div>
              {showRegisterLink ? (
                <div className="text-right pb-8 pr-8">
                  <p className="text-slate-300 text-lg">
                    Ainda não se cadastrou?
                  </p>
                  <Link
                    to="/cadastro"
                    className="text-slate-200 text-lg font-semibold hover:underline">
                    Registre-se aqui!
                  </Link>
                </div>
              ) : (
                <div className="text-right pb-8 pr-8">
                  <p className="text-slate-300 text-lg">Já tem cadastro?</p>
                  <Link
                    to="/login"
                    className="text-slate-200 text-lg font-semibold hover:underline">
                    Voltar ao login
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
